export const AI_TAGS_ON_PAGE = 20;

export const AI_TAG_CATEGORY_LABELS: Record<string, string> = {
  developer: 'Девелопер',
  company: 'Компания',
  personality: 'Персона',
  person: 'Персона',
  project: 'Проект',
  location: 'Локация',
  organization: 'Организация',
  other: 'Прочее',
};

export const getAiTagCategoryLabel = (category?: string | null) => {
  if (!category) return '—';
  return AI_TAG_CATEGORY_LABELS[category] || category;
};

export const AI_TAG_SHOW_BODY_OPTIONS = [
  {
    value: 'true',
    content: 'Показать',
  },
  {
    value: 'false',
    content: 'Скрыть',
  },
];

export const isAiTagShowBodyValue = (value: string): boolean =>
  AI_TAG_SHOW_BODY_OPTIONS.some((option) => option.value === value);
